module.exports = __webpack_public_path__ + "static/media/car360.e839e55f.svg";